import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { GalleryCarousel } from './GalleryCarousel';
import { GallerySummary } from './GallerySummary';
import { GallerySection } from '@/types/sections/GallerySection';

// ----------------------------------------------------------------------

type Props = {
  section?: GallerySection;
};

export default function Gallery({ section }: Props) {
  return (
    <Container sx={{ mt: { xs: 2, md: 10 }, mb: 10 }}>
      <Grid container spacing={{ xs: 3, md: 5, lg: 8 }}>
        <Grid size={{ xs: 12, md: 6, lg: 7 }}>
          <GalleryCarousel images={section?.images} />
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 5 }}>
          {section && (
            <GallerySummary section={section} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
}
